import clsx from 'clsx';
import type { RefObject } from 'react';
import { PhoneInput as IntlPhoneInput, type PhoneInputRefType } from 'react-international-phone';

import s from './inputs.module.scss';
import { normalizePhoneValue } from './phoneValue';

import 'react-international-phone/style.css';

export const PhoneInput = ({
  label,
  value,
  onChange,
  error,
  mandatory,
  className,
  defaultCountry = 'us',
  ref,
  id = 'phone',
  name,
  autoComplete,
}: {
  /** Omitted where a column header already names the field, as in a table row. */
  label?: string;
  value?: string;
  onChange: (value?: string) => void;
  error?: string;
  mandatory?: boolean;
  className?: string;
  defaultCountry?: string;
  ref?: RefObject<PhoneInputRefType>;
  /**
   * Distinguishes one phone field from another on pages that render several —
   * a row per day worker, say. Without it every label points at the first
   * input on the page, and clicking any of them focuses that one.
   */
  id?: string;
  name?: string;
  autoComplete?: string;
}) => {
  return (
    <label className={clsx(s.InputRoot, className)} htmlFor={id}>
      {label && (
        <div className={s.Label}>
          <span>{label}</span>
          {mandatory && <span>*</span>}
        </div>
      )}

      <div className={clsx(s.InputWrapper, error && s.error)}>
        <IntlPhoneInput
          defaultCountry={defaultCountry}
          value={value}
          // The input reports its dial-code prefill (e.g. `+1`) on mount, which
          // normalizes to '' - so a bare `+1` is never stored or sent to the
          // backend until the user types a real national number.
          onChange={(phone, meta) => onChange(normalizePhoneValue(phone, meta.country.dialCode))}
          className="body-medium"
          inputProps={{ id, name, autoComplete }}
          charAfterDialCode="-"
          countrySelectorStyleProps={{ flagStyle: { width: '20px', height: '20px' } }}
          ref={ref}
        />
      </div>

      {!!error && <p className={s.Error}>{error}</p>}
    </label>
  );
};
